import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import sidebarLinksData from "../data/sidebarLinks.json";
import { Link } from "react-router-dom";
import Icon from "../ui/icons/Icon";
import { LogOut } from "lucide-react";
import useAuth from "../hooks/useAuth";
import { FOCUS_RING } from "./form/styles";

interface sidebarProps {
    pathname: string;
}

interface sidebarLinks {
    name: string;
    subPath: string,
    icon: string;
}

const ActionBar = ({ pathname }: sidebarProps) => {
    const [links, setLinks] = useState<sidebarLinks[]>([]);
    const { t } = useTranslation();
    const { logout } = useAuth();
    const isAdminArea = pathname.split("/")[1] === "admin";
    useEffect(() => {
        switch (pathname.split("/")[1]) {
            case "teacher":
                setLinks(sidebarLinksData.teacher);
                break;
            case "family":
                setLinks(sidebarLinksData.family);
                break;
            case "admin":
                setLinks(sidebarLinksData.admin);
                break;
            default:
                setLinks(sidebarLinksData.family);
                break;
        }
    }, [pathname]);
    return (
        <>
            <nav id="actionBar" aria-label={t('shell.mainNav')} className="fixed bottom-0 left-0 w-full bg-white p-2 flex justify-around items-center shadow-md z-10">
                {links.map((link, index) => {
                    const isActive = pathname === link.subPath;
                    return (
                        <Link
                            key={index}
                            className={`flex flex-col ${isActive ? 'align-top active' : 'align-top'}`}
                            to={link.subPath}
                            aria-current={isActive ? 'page' : undefined}>
                            <div className={`rounded-lg flex flex-col py-1 mx-auto`} aria-hidden="true">
                                <Icon
                                    iconName={link.icon}
                                    options={{
                                        width: 24,
                                        height: 24,
                                        activeState: isActive,
                                        className: 'mx-auto'
                                    }} />
                            </div>
                            <span className={`text-sm font-bold text-center ${isActive ? 'text-fpcred' : 'text-gray-500'}`}>{t("actionbar." + link.name)}</span>
                        </Link>
                    )
                })}
                {isAdminArea && (
                    <button
                        type="button"
                        onClick={logout}
                        className={`flex flex-col items-center rounded-lg ${FOCUS_RING}`}>
                        <span className="py-1" aria-hidden="true">
                            <LogOut className="h-6 w-6 text-gray-500" />
                        </span>
                        <span className="text-sm font-bold text-center text-gray-500">{t("loggedMenuLogout")}</span>
                    </button>
                )}
            </nav>
        </>
    );
}

export default ActionBar;
